////////////////////////////////////////////////////////////////////////////////
//                                                                            //
//  IRONSIDE - Public Website GUI                                             //
//                                                                            //
//  Version: 1.0.3                                                            //
//  Summary: Privacy/Cookies/Terms route — three sections, in-page anchors  //
//                                                                            //
////////////////////////////////////////////////////////////////////////////////

import { usePageTitle } from '@/hooks/usePageTitle';
import { getPage, splitSections } from '@/lib/content';
import { Markdown } from '@/components/content/Markdown';
import { GlassTile } from '@/components/content/GlassTile';
import { PageHero } from '@/components/content/PageHero';
import { Reveal } from '@/components/content/Reveal';

export function Legal () {
  usePageTitle('Privacy, Cookies, Terms & Conditions');

  const page = getPage('privacy-cookies-terms-conditions');
  if (!page) return null;

  const sections = splitSections(page.bodyMd);
  const namedSections = sections.filter((s) => s.heading !== '');

  return (
    <div>
      {/* MARK — 1.0.3: the intro's scraped hero photo is no longer rendered
          inline — the persistent <BackgroundLayer /> already carries the
          /legal background for this route (1.0.3.md §4/§5); a second,
          page-local hero image would fight it. */}
      <PageHero title="Privacy, Cookies, Terms & Conditions" />

      <div className="mx-auto max-w-6xl px-6 py-16">
        <Reveal as="nav" aria-label="On this page">
          <GlassTile className="p-6">
            <ul className="flex flex-wrap gap-4 text-sm">
              {namedSections.map((section) => (
                <li key={section.id}>
                  <a href={`#${section.id}`} className="underline">{section.heading}</a>
                </li>
              ))}
            </ul>
          </GlassTile>
        </Reveal>

        <div className="mt-10 space-y-10">
          {namedSections.map((section) => (
            <Reveal key={section.id} as="section" id={section.id}>
              {/* Long-form legal copy — the quieter "prose" tile finish
                  (1.0.3.md §6, styles/glass.css's `.glass-tile--prose`). */}
              <GlassTile className="glass-tile--prose p-8 sm:p-12" aria-labelledby={`${section.id}-heading`}>
                <h2 id={`${section.id}-heading`} className="text-2xl font-semibold text-ink">{section.heading}</h2>
                <Markdown source={section.bodyMd} className="mt-4" />
              </GlassTile>
            </Reveal>
          ))}
        </div>
      </div>
    </div>
  );
}
